import * as React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
  BrowserRouter,
  HashRouter,
} from "react-router-dom";

import "./App.css";

import "react-circular-progressbar/dist/styles.css";

import IndexPage from "./pages/Index";
import LoginPage from "./pages/Login";
import NotFoundPage from "./pages/NotFound";

import CreateRequest from "./pages/Request/CreateRequest";
import ListRequest from "./pages/Request/RequestList";
import RequestDetail from "./pages/Request/RequestDetail";

import ListFaq from "./pages/Faq/FaqList";
import FaqDetail from "./pages/Faq/FaqDetail";

import Header from "./components/layout/Header";
import PrivateRoute from "./components/layout/PrivateRoute";

import { useSelector, useDispatch } from "react-redux";
import { selectUser, logout } from "./store/modules/AuthStore";
import { useEffect } from "react";

import { TokenService } from "./services/LocalStorage";

import {
  AppContainer,
  AppInnerContainer,
} from "./components/HomePage/HomeElements";


import MarketPlace from "./pages/MarketPlace/index";
import RequestMarketPlace from "./pages/MarketPlace/requestMarketPlace";
import { ToastContainer } from "react-toastify";

interface CustomDocument extends Document {
  timeOutHelpPeople?:  ReturnType<typeof setTimeout>;
}


const App: React.FC = () => {
  // Jacobo
  const sessionTimeString = localStorage.getItem('sessionTime');
  const timeLimit = sessionTimeString ? parseInt(sessionTimeString) : 38000;
  const customDocument = document as CustomDocument;

  // declaring a user which is coming from store
  const user = useSelector(selectUser);
  const dispatch = useDispatch()
  
  // initialize this variable as false
  let isAuthenticated = false;
  
  // if the token in the local strorage exist and it is not an empty string, then authorize user
  if (TokenService.get() !== "") isAuthenticated = true;
  
  const defaultProtectedRouteProps: ProtectedRouteProps = {
    isAuthenticated,
    authenticationPath: "/",
    redirectPath: "/",
    setRedirectPath: "/",
  };

  useEffect(()=>{
    return () => {
      window.removeEventListener("storage", storageListener)
    };
  }, [])

  const storageListener = () => {
    
    if (!localStorage.getItem("token")) {
      handleLogout()
    }
    else if (localStorage.getItem("token") && localStorage.getItem("sessionTime")){
      updateLastActiveAndBroadcast()
      
    }
  }

  window.addEventListener('storage', storageListener );
  
  const handleLogout = () => {

    const currentDate = new Date();
    const localStorageDate = localStorage.getItem('lastActive');
    const lastActive = new Date(localStorageDate || 0);
 
    if ((currentDate.getTime() - lastActive.getTime()) / 1000 >= timeLimit || !localStorage.getItem("token")) {
      window.removeEventListener("storage", storageListener)
      // Swal.fire('La sesión ha caducado. Por favor inicie sesión nuevamente');
      localStorage.clear()
      if(customDocument.timeOutHelpPeople){
        clearTimeout(customDocument.timeOutHelpPeople)
      }
      dispatch(logout())
    }    
  };

  const updateLastActiveAndBroadcast = () => { 
    const currentDate = new Date()
    localStorage.setItem('lastActive', currentDate.toString());

    if(customDocument.timeOutHelpPeople){
      clearTimeout(customDocument.timeOutHelpPeople)
    }
    customDocument.timeOutHelpPeople = setTimeout(handleLogout, timeLimit * 1000);
  };
  
  const Default = () => {
    return (
      <HashRouter basename="/">
        <Switch>
          <Route
            {...defaultProtectedRouteProps}
            path="/"
            exact
            component={LoginPage}
          />
          <Redirect to={`/`} />
        </Switch>
      </HashRouter>
    );
  };

  const Dashboard = () => {
    return (
      <main className="test" onMouseMove={() => {
        if(localStorage.getItem("token") && localStorage.getItem("sessionTime")){
          updateLastActiveAndBroadcast();
        }else if(customDocument.timeOutHelpPeople){
          clearTimeout(customDocument.timeOutHelpPeople)
        }
        // clearInterval(this._interval);
        // this._interval = setInterval(() => {
        //   this.props.authLogout(this.props.history);
        // }, this.state.inactivityTime * 60000);
      }}>
        <HashRouter basename="/">
          <div>
            <Header />
            <AppContainer className="sm:px-2 md:px-6 lg:px-0">
              <div>
                <AppInnerContainer>
                  <Switch>
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/"
                      exact
                      component={IndexPage}
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/request/new"
                      exact
                      component={CreateRequest}
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/request/all"
                      exact
                      component={ListRequest}
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/request/:id"
                      exact
                      component={RequestDetail}
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/faq/all"
                      exact
                      component={ListFaq}
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/faq/:id"
                      exact
                      component={FaqDetail}
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/rfc/all"
                      exact
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/rfc/:id"
                      exact
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/marketPlace/index"
                      exact
                      component={MarketPlace}
                    />
                    <PrivateRoute
                      {...defaultProtectedRouteProps}
                      path="/marketPlace/requestMarketPlace"
                      exact
                      component={RequestMarketPlace}
                    />
                    <Route component={NotFoundPage} />
                  </Switch>
                </AppInnerContainer>
              </div>
            </AppContainer>
          </div>
        </HashRouter>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          draggable
          pauseOnHover
        /> 
        {/* Se estaban repitiendo los toast dos veces* */}
      </main>

    );
  };

  return (
    <>
      {" "}
      {user.error === "" && user.token !== "-1" ? (
        <Dashboard />
      ) : (
        <Default />
      )}{" "}
    </>
  );
};

export default App;
